import { UserRole } from '@lmc/ts-common'

/**
 * Pay-rates and invoicing features — reconciliation, pay/charge reports, and
 * pay-rate/charge-rate management — are available to both the admin and the
 * management roles. Extended from admin-only in ROST-3440.
 */
export const canManagePayAndInvoicing = (
  role: string | null | undefined
): boolean => role === UserRole.careHomeAdmin || role === UserRole.management
